/** DOM ids on the AdBasicsStep Facebook Page field. Exported so
 *  tests (and any future consumer that needs to programmatically walk
 *  the aria-describedby chain) don't hardcode the same strings.
 *  Lives in a sibling module because AdBasicsStep is a Fast-Refresh-
 *  eligible component file — mixing const exports with the component
 *  export trips `react-refresh/only-export-components`.
 */
export const PAGE_FIELD_IDS = {
  inheritedCaption: 'meta-ad-page-inherited-caption',
  pendingCaption: 'meta-ad-page-pending-caption',
  error: 'meta-ad-page-error',
} as const;
